import { format, parse } from 'date-fns';
import { propsDecorator } from '@/js/common/Domain/Service/mixins/decorators';

@propsDecorator({
    defaults: {
        id: null,
        price: null,
        checkInDate: null,
        hotelAvailable: null,
        medicalInsurance: null,
        maxHistoricalPrice: null,
        nights: null,
        touristGroup: null,
        meal: null,
        country: null,
        resort: null,
        hotel: null,
        hotelCategory: null,
        operator: null,
        sortRate: null,
        firstPaymentDefinitions: null,
        cashbackAvailable: null,
        discount: null,
        room: null,
        routes: null,
    },

    computeds: {
        startDate: {
            deps: ['routes', 'checkInDate'],
            get: (routes, checkInDate) => {
                const routeStartDate = routes && routes.length && routes[0].there?.legs?.[0].departureDate ? routes[0].there.legs[0].departureDate : null;

                if (routeStartDate) {
                    return format(parse(routeStartDate, 'yyyy-MM-dd HH:mm:ss', new Date()), 'yyyy-MM-dd');
                }

                return checkInDate;
            },
        },
        paymentCashBackRailwayTour: {
            deps: ['price'],
            get(price) {
                const maxCashBackMir = 20000;
                const paymentCashBackMirHotel = Math.ceil(price * 0.8);
                const cashBackMir = price - paymentCashBackMirHotel;
                return (cashBackMir > maxCashBackMir) ? price - maxCashBackMir : paymentCashBackMirHotel;
            },
        },
    },
})
export default class extends Backbone.Epoxy.Model {
}